import axios from 'axios';

/**
 * Indicators (configurable targets) - backed by the core-api `/indicators`,
 * `/indicators/catalog`, `/indicators/evaluate` and `/indicator-results`
 * endpoints. Dates are epoch-ms in the global module and sent as ISO strings.
 */

const toISO = value => new Date(value).toISOString();

const actions = {
  // GET /indicators/catalog -> [{ key, label, unit, betterWhen }]
  catalog() {
    return axios.get('/indicators/catalog').then(({ data }) => data || []);
  },

  // GET /indicators -> paginated list of definitions
  list() {
    return axios.get('/indicators', { params: { $limit: 200, '$sort[order]': 1 } })
      .then(({ data }) => (data && data.data) || data || []);
  },

  create(context, body) {
    return axios.post('/indicators', body).then(({ data }) => data);
  },

  update(context, { id, body }) {
    return axios.patch(`/indicators/${id}`, body).then(({ data }) => data);
  },

  remove(context, id) {
    return axios.delete(`/indicators/${id}`).then(({ data }) => data);
  },

  // POST /indicators/evaluate -> { start, end, results: [{ ...actual vs target }] }
  evaluate(context, { start, end }) {
    return axios.post('/indicators/evaluate', { start: toISO(start), end: toISO(end) })
      .then(({ data }) => data);
  },

  // GET /indicator-results -> daily snapshots for one indicator (trend)
  results(context, { indicator, start, end }) {
    return axios.get('/indicator-results', {
      params: {
        indicator,
        'date[$gte]': toISO(start),
        'date[$lte]': toISO(end),
        '$sort[date]': 1,
        $limit: 500,
      },
    }).then(({ data }) => (data && data.data) || []);
  },
};

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions,
  getters: {},
};
